import PropTypes from "prop-types"
import React from "react"

import Tooltip from "src/components/Tooltip"

const JourneyStageCell = ({ step }) => {
  const label = step.failureTooltip ? (
    <Tooltip
      text={step.failureTooltip}
      placement="top"
      variant="dark"
      maxWidth="400px"
    >
      <span className="font-semibold text-red-600">{step.label}</span>
    </Tooltip>
  ) : (
    step.label
  )

  return (
    <div className="mt-1 text-xs text-gray-900">
      {step.summary && <span className="font-semibold">{step.summary} </span>}
      {label}
    </div>
  )
}

JourneyStageCell.propTypes = {
  step: PropTypes.shape({
    index: PropTypes.number,
    total: PropTypes.number,
    summary: PropTypes.string,
    label: PropTypes.string.isRequired,
    failureTooltip: PropTypes.string,
  }).isRequired,
}

export default JourneyStageCell
